













































































































import { SketchRelatedData } from '@tt4b/ttam-enums';
import { i18n } from '@tt4b/ttam-i18n';
import { trackEvent } from '@tt4b/ttam-utils';
import { useAutoSaveSketchRelatedData } from '@tt4b/ttam-hooks';
import { computed, defineComponent, PropType, toRefs, ref, watch } from '@vue/composition-api';

const name = 'ttam-auto-save-exit-dialog';
export default defineComponent({
  name,
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isSupportDraft: {
      type: Boolean,
      default: false,
    },
    campaignSketchRelatedData: {
      type: Object as PropType<SketchRelatedData>,
      default: () => ({}),
    },
    adgroupSketchRelatedData: {
      type: Object as PropType<SketchRelatedData>,
      default: () => ({}),
    },
    creativeSketchRelatedData: {
      type: Object as PropType<SketchRelatedData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { campaignSketchRelatedData, adgroupSketchRelatedData, creativeSketchRelatedData } = toRefs(props);
    const {
      isCampaignSketchReachLimitError,
      isAdgroupSketchReachLimitError,
      isCreativeSketchReachLimitError,
      isSketchSaved,
      isSketchSaving,
      isSketchSaveError,
      isSketchReachLimit,
      isSketchPublished,
      isSketchDeleted,
      lastAutoSaveTime,
      isHasDraftId,
    } = useAutoSaveSketchRelatedData({
      campaignSketchRelatedData,
      adgroupSketchRelatedData,
      creativeSketchRelatedData,
    });

    const isDraftSavedNotShowAnymore = ref(false);

    const exitDialogTitle = computed(() => {
      switch (true) {
        case !props.isSupportDraft:
          return i18n.t('module_exit_dialog_title');
        case isSketchSaved.value:
          return i18n.t('draft_auto_save_success_exit_dialog_title');
        case isSketchReachLimit.value:
          return i18n.t('draft_auto_save_error_exit_dialog_reach_limit_title');
        case isSketchDeleted.value:
          return i18n.t('draft_auto_save_error_exit_dialog_be_deleted_title');
        case isSketchPublished.value:
          return i18n.t('draft_auto_save_error_exit_dialog_be_published_title');
        case isSketchSaveError.value:
          return isHasDraftId.value
            ? i18n.t('draft_auto_save_error_exit_dialog_generic_error_has_draft_title')
            : i18n.t('draft_auto_save_error_exit_dialog_generic_error_without_draft_title');
        default:
          return i18n.t('module_exit_dialog_title');
      }
    });

    const exitDialogExitText = computed(() => {
      if (props.isSupportDraft && isSketchSaved.value) {
        return i18n.t('module_bottom_bar_exit');
      } else {
        return i18n.t('module_common_exit_without_saving');
      }
    });

    const exitDialogStayText = computed(() => i18n.t('module_continue_to_edit'));

    const handleClose = () => {
      isDraftSavedNotShowAnymore.value = false;
      emit('close');
    };

    const handleExit = () => {
      if (!props.isSupportDraft) {
        trackEvent('ttam_creation_draft_exit_on_no_draft_support_exit');
      } else if (isSketchSaved.value) {
        trackEvent('ttam_creation_draft_success_exit_exit');
      } else if (isSketchReachLimit.value) {
        trackEvent('ttam_creation_draft_exit_on_error_upper_limit_exit');
      } else if (isSketchDeleted.value) {
        trackEvent('ttam_creation_draft_exit_on_error_draft_deleted_exit');
      } else if (isSketchPublished.value) {
        trackEvent('ttam_creation_draft_exit_on_error_draft_published_exit');
      } else if (isSketchSaveError.value) {
        if (isHasDraftId.value) {
          trackEvent('ttam_creation_draft_exit_on_error_unsaved_edits_exit');
        } else {
          trackEvent('ttam_creation_draft_exit_on_error_no_draft_saved_exit');
        }
      }
      emit('exit', isDraftSavedNotShowAnymore.value);
      handleClose();
    };

    const handleStay = () => {
      if (!props.isSupportDraft) {
        trackEvent('ttam_creation_draft_exit_on_no_draft_support_stay');
      } else if (isSketchSaved.value) {
        trackEvent('ttam_creation_draft_success_exit_stay');
      } else if (isSketchSaveError.value && !isSketchReachLimit.value) {
        if (isSketchDeleted.value) {
          trackEvent('ttam_creation_draft_exit_on_error_draft_deleted_stay');
        } else if (isSketchPublished.value) {
          trackEvent('ttam_creation_draft_exit_on_error_draft_published_stay');
        } else if (isHasDraftId.value) {
          trackEvent('ttam_creation_draft_exit_on_error_unsaved_edits_stay');
        } else {
          trackEvent('ttam_creation_draft_exit_on_error_no_draft_saved_stay');
        }
      }
      handleClose();
    };

    const handleManageDraft = () => {
      trackEvent('ttam_creation_draft_exit_on_error_upper_limit_manager_draft');
      emit('manage-draft');
    };

    const handleRetry = () => {
      emit('retry');
      if (!isSketchReachLimit.value) {
        if (isHasDraftId.value) {
          trackEvent('ttam_creation_draft_exit_on_error_unsaved_edits_tryagain');
        } else {
          trackEvent('ttam_creation_draft_exit_on_error_no_draft_saved_tryagain');
        }
      }
    };

    watch(
      props,
      () => {
        if (props.visible) {
          if (!props.isSupportDraft) {
            trackEvent('ttam_creation_draft_exit_on_no_draft_support');
          } else if (isSketchSaved.value) {
            trackEvent('ttam_creation_draft_success_exit_window');
          } else if (isSketchSaveError.value && !isSketchReachLimit.value) {
            if (isSketchDeleted.value) {
              trackEvent('ttam_creation_draft_exit_on_error_draft_deleted');
            } else if (isSketchPublished.value) {
              trackEvent('ttam_creation_draft_exit_on_error_draft_published');
            } else if (isHasDraftId.value) {
              trackEvent('ttam_creation_draft_exit_on_error_unsaved_edits');
            } else {
              trackEvent('ttam_creation_draft_exit_on_error_no_draft_saved');
            }
          }
        }
      },
      { immediate: true },
    );

    return {
      name,
      exitDialogTitle,
      exitDialogExitText,
      exitDialogStayText,
      isDraftSavedNotShowAnymore,
      isCampaignSketchReachLimitError,
      isAdgroupSketchReachLimitError,
      isCreativeSketchReachLimitError,
      isSketchSaved,
      isSketchSaving,
      isSketchSaveError,
      isSketchReachLimit,
      isSketchPublished,
      isSketchDeleted,
      lastAutoSaveTime,
      isHasDraftId,
      handleExit,
      handleClose,
      handleStay,
      handleManageDraft,
      handleRetry,
    };
  },
});
